import BASEURLGESTTOR from '../api/gesttor'
import { CadastrarNivelPayload, AtualizarNivelPayload, listarNiveisQuery } from '../../interfaces/conquistaNivel'

export function listarNiveis({ titulo, situacao }: listarNiveisQuery) {
    return BASEURLGESTTOR.get(`/nivel?titulo=${titulo || ""}&situacao=${situacao || ""}`)
}

export function cadastrarNivel(payload: CadastrarNivelPayload) {
    return BASEURLGESTTOR.post(`/nivel`, payload)
}

export function atualizarNivel(id: string, payload: AtualizarNivelPayload) {
    return BASEURLGESTTOR.patch(`/nivel/${id}`, payload)
}
